import { map } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DomainDataFacade } from '@mitsubishi/core';
import { SelectModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-segment-selection',
  templateUrl: './segment-selection.component.html',
  styleUrls: ['./segment-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, SelectModule],
})
export class SegmentSelectionComponent {
  @Input() bindValue = 'id';
  @Input() selectedSegment: number[] | number | undefined | null;
  @Input() multiple = true;
  @Input() acceptedValues: number[] | undefined;

  @Output() segmentChanged = new EventEmitter<any>();

  private commonDataFacade = inject(DomainDataFacade);

  segments$ = this.commonDataFacade.segments$.pipe(
    map(segments => {
      if (!this.acceptedValues) {
        return segments;
      }

      return segments.filter(segment => this.acceptedValues?.includes(segment.id));
    })
  );

  onSegmentSelectionChanged() {
    this.segmentChanged.emit(this.selectedSegment);
  }
}
